import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export interface RevenueMonth {
  month: string;
  amount: string;
}

/** "All Revenue Months": every analysed month's revenue. With `onPick`, a month is a button. */
export function RevenueMonthsDialog({
  open,
  onOpenChange,
  months,
  onPick,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  months: RevenueMonth[];
  onPick?: (month: string) => void;
}) {
  const row = "flex items-center justify-between rounded-md border border-border p-3 text-left";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>All Revenue Months</DialogTitle>
        </DialogHeader>
        <div className="flex max-h-[60vh] flex-col gap-2 overflow-y-auto pt-2">
          {months.map(({ month, amount }) => {
            const content = (
              <>
                <span className="font-medium">{month}</span>
                <span className="font-bold text-foreground">{amount}</span>
              </>
            );
            return onPick ? (
              <button
                key={month}
                type="button"
                onClick={() => onPick(month)}
                className={cn(row, "hover:bg-muted/60")}
              >
                {content}
              </button>
            ) : (
              <div key={month} className={row}>
                {content}
              </div>
            );
          })}
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
